import { render, staticRenderFns } from "./EditContactDetails.vue?vue&type=template&id=d1c80a18&"
import script from "./EditContactDetails.vue?vue&type=script&lang=ts&"
export * from "./EditContactDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports